module.exports = __webpack_public_path__ + "fontawesome-webfont.d9ee23d59d0e0e727b51.woff";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/vendors/ng-prime/fonts/fontawesome-webfont.woff?v=4.3.0
// module id = ../../../../../src/assets/vendors/ng-prime/fonts/fontawesome-webfont.woff?v=4.3.0
// module chunks = 2